import React from 'react';
import { Modal, Button, Result } from 'antd';
import { Trans } from "@lingui/react";

const MessageSendModal = ({ visible, onClose }) => {
    return (
        <Modal
            open={visible}
            footer={null}
            onCancel={onClose}
            centered
            width={500}
        >
            <Result
                status="success"
                title={<Trans id="messageSentSuccessfully" />}
                // subTitle={<Trans id='success.subTitle' />}
                extra={[
                    <Button key="close" onClick={onClose}>
                        Close
                    </Button>,
                ]}
            />
        </Modal>
    );
};

export default MessageSendModal;

